import { LogoutService } from "./logout-service";
import { DialogService } from "../dialog";
import { LocalizationService } from "../../../ShellCommon/localization/localization";

export class LogoutDialog {
  // @ngInject
  constructor(
    private sdLocalizationService: LocalizationService,
    private dialogService: DialogService,
    private logoutService: LogoutService
  ) {}

  public logout() {
    this.logoutService.performLogout();
  }

  public close() {
    this.dialogService.hide();
  }
}
